__webpack_require__.p = "/gomoji/";